export const sizes = {
  card: {
    lg: '43.125rem',
    md: '31.25rem',
  },
};

export default sizes;
